module.exports = __webpack_public_path__ + "img/VideoTerminal.cd549be8.png";